import { gql } from '@apollo/client'

export const CRS_INVENTORY_QUERY = gql`
  query CrsInventory($input: InventoryInput!) {
    crsInventory(input: $input) {
      roomTypes {
        basicDetails {
          name
          roomTypeCode
          displayRoomTypeCode
          defaultOccupancy
          numberOfRooms
          providers {
            basicDetails {
              name
              providerCode
              displayProviderCode
              id
              addOns {
                name
                nameTranslatedList {
                  label
                  nativeLabel
                  value
                }
                code
                type
              }
              ratePlans {
                basicDetails {
                  name
                  ratePlanCode
                  displayRatePlanCode
                }
                dataForEachDate {
                  date
                  closed {
                    value
                    manual
                  }
                  cta {
                    value
                    manual
                  }
                  ctd {
                    value
                    manual
                  }
                  minStay {
                    value
                    manual
                  }
                  maxStay {
                    value
                    manual
                  }
                  price {
                    price {
                      value
                      manual
                    }
                    occupancy
                  }
                  addOns {
                    type
                    amount {
                      value
                      manual
                    }
                    code
                  }
                }
              }
            }
            dataForEachDate {
              date
              availability {
                value
                manual
              }
              totalAllocatedAvailability {
                value
                manual
              }
              reservedPooled {
                value
                manual
              }
              reservedAllocate {
                value
                manual
              }
            }
          }
        }
        dataForEachDate {
          date
        }
      }
    }
  }
`

export const CHANNEL_INVENTORY_QUERY = gql`
  query ChannelInventory($input: InventoryInput!) {
    channelInventory(input: $input) {
      channelID
      channelName
      ratePlans {
        basicDetails {
          name
          ratePlanCode
          displayRatePlanCode
        }
        dataForEachDate {
          date
          closed {
            value
            manual
          }
          cta {
            value
            manual
          }
          ctd {
            value
            manual
          }
          minStay {
            value
            manual
          }
          maxStay {
            value
            manual
          }
          price {
            price {
              value
              manual
            }
            occupancy
            discountPercent
          }
          addOns {
            type
            amount {
              value
              manual
            }
            code
          }
          availability {
            value
            manual
          }
          pooledAvailability {
            value
            manual
          }
          allocatedAvailability {
            value
            manual
          }
        }
      }
    }
  }
`

export const RESET_CRS_INVENTORY_MUTATION = gql`
  mutation ResetCRSInventory($input: ResetCRSInventoryInput!) {
    resetCRSInventory(input: $input) {
      trackingID
    }
  }
`

export const RESET_CHANNEL_INVENTORY_MUTATION = gql`
  mutation ResetChannelInventory($input: ResetChannelInventoryInput!) {
    resetChannelInventory(input: $input) {
      trackingID
    }
  }
`

export const RESET_RESERVED_AVAILABILITY_MUTATION = gql`
  mutation ResetReservedAvailability($input: ResetReservedAvailabilityInput!) {
    resetReservedAvailability(input: $input) {
      trackingID
    }
  }
`

export const RESERVED_FIELDS_QUERY = gql`
  query ReservedFields($input: ReservedFieldsInput!) {
    reservedFields(input: $input) {
      CRSNumber
      version
      action
      createdAt
      updatedAt
      deletedAt
      deletedBy
    }
  }
`
